module.exports = __webpack_public_path__ + "img/ic_edit.fd9a0b42.svg";